

















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { bus } from '../main'
import VueSlider from 'vue-slider-component'

@Component({
	components: {
		VueSlider
	}
})
export default class QuestionTerms extends Vue {
	@Prop({required: true}) entityChoices!: {salary: {min: number, max: number}, hours: {min: number, max: number}, car: string}
	@Prop({required: true}) defaultCar!: {options: {value: string, label: string}}
	@Prop({required: true}) defaultSalary!: {min: number, max: number, step: number, default: {min: number, max: string}}
	@Prop({required: true}) defaultHours!: {min: number, max: number, step: number, default: {min: number, max: string}}
	@Prop({required: true}) questionIndex!: number

	savedSalary: {min: number, max: number} = {min: 0, max: 0}
	savedHours: {min: number, max: number} = {min: 0, max: 0}
	savedCar: string = ''

	get salary() {
		return [this.entityChoices.salary.min, this.entityChoices.salary.max]
	}
	set salary(newValues: number[]) {
		this.savedSalary = {
			min: newValues[0],
			max: newValues[1]
		}

		this.updateEntityTerms()
	}

	get hours() {
		return [this.entityChoices.hours.min, this.entityChoices.hours.max]
	}
	set hours(newValues: number[]) {
		this.savedHours = {
			min: newValues[0],
			max: newValues[1]
		}

		this.updateEntityTerms()
	}

	get car() {
		return this.entityChoices.car
	}
	set car(newValues: string) {
		this.savedCar = newValues

		this.updateEntityTerms()
	}

	get salaryMarks() {
		return {
			[this.defaultSalary.min]: this.flatCurrencyByNumber(this.defaultSalary.min),
			[this.defaultSalary.max]: this.flatCurrencyByNumber(this.defaultSalary.max)
		}
	}

	flatCurrencyByNumber(value: number): string {
		return new Intl.NumberFormat('nl-NL', {
			style: 'currency',
			currency: 'EUR',
			minimumFractionDigits: 0
		})
			.format(value)
			.replace(/\s/g, '')
	}
	updateEntityTerms() {
		bus.$emit('updateEntityTerms', {
			questionIndex: this.questionIndex,
			entityTerms: {
				salary: {
					min: this.savedSalary.min,
					max: this.savedSalary.max
				},
				hours: {
					min: this.savedHours.min,
					max: this.savedHours.max
				},
				car: this.savedCar
			}
		})
	}

	mounted() {
		this.savedSalary = {
			min: this.entityChoices.salary.min,
			max: this.entityChoices.salary.max
		}
		this.savedHours = {
			min: this.entityChoices.hours.min,
			max: this.entityChoices.hours.max
		}
		this.savedCar = this.entityChoices.car
	}
}
